import * as React from 'react';
import * as style from './LastChanceDiscountIllustration.css';

export const LastChanceDiscountIllustration: React.FC = () => {
  return <div className={style['image']} data-testid="LastChanceDiscountIllustration" />;
};
